import { BaseFragmentController } from 'src/app/View/BaseUI/BaseFragmentController';
import { DeliveryAddressConfirmFragmentComponent } from './DeliveryAddressConfirmFragmentComponent';
import {ExamAfterProcessService} from '../../../../../../Service/ExamAfterProcessService';

export class DeliveryAddressConfirmFragmentController extends BaseFragmentController {

	// 対となるView
	public combineView: DeliveryAddressConfirmFragmentComponent;

	public async createPaymentUrl(param: { view: any; paymentId: number }): Promise<{processUrl: string}> {
		const svc = new ExamAfterProcessService(param.view);
		const ret = await svc.createPaymentUrl(param.paymentId);
		return ret;
	}

}
